import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _IconAdd, _ContainerTableColumn;
var _excluded = ["readOnly"];
import React from 'react';
import { ContainerTable, ContainerTableColumn, useIntl } from '@lumahealthhq/ui-components';
import { Box, Button, IconAdd, Stack, Typography } from '@lumahealthhq/ui-core';
import { EModel } from '@lumahealthhq/ui-model-types';
import { useNavigateToModule } from '../hooks';
import { EModule } from '../types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EModelChecklistTemplate = EModel.ChecklistTemplate;
export default function FallbackContainerTableChecklistTemplate(_ref) {
  var readOnly = _ref.readOnly,
    rest = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var navigateToModule = useNavigateToModule();
  var handleClick = function handleClick() {
    navigateToModule(EModule.FormChecklistTemplate, {
      id: 'add'
    });
  };
  var renderLabel = React.useCallback(function () {
    return intl.formatMessage({
      id: "zQvVDJ",
      defaultMessage: [{
        "type": 0,
        "value": "All"
      }]
    });
  }, [intl]);
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 5,
    sx: {
      height: '100%',
      width: '100%'
    },
    children: [/*#__PURE__*/_jsxs(Stack, {
      direction: "row",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        children: intl.formatMessage({
          id: "qZZl8H",
          defaultMessage: [{
            "type": 0,
            "value": "Checklist Builder"
          }]
        })
      }), !readOnly && /*#__PURE__*/_jsx(Button, {
        startIcon: _IconAdd || (_IconAdd = /*#__PURE__*/_jsx(IconAdd, {})),
        variant: "primary",
        onClick: handleClick,
        children: intl.formatMessage({
          id: "gV8AIA",
          defaultMessage: [{
            "type": 0,
            "value": "Add Checklist"
          }]
        })
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        flex: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto'
      },
      children: /*#__PURE__*/_jsxs(ContainerTable, _extends({
        model: EModelChecklistTemplate,
        renderLabel: renderLabel,
        tableContainerProps: {
          sx: {
            minHeight: '0'
          }
        },
        queryOptions: {
          enabled: false
        },
        isLoading: true
      }, rest, {
        children: [/*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "name",
          sx: {
            minWidth: '200px',
            maxWidth: '350px'
          },
          tableCellProps: {
            sx: {
              minWidth: '200px',
              maxWidth: '350px'
            }
          },
          title: intl.formatMessage({
            id: "EBOkPG",
            defaultMessage: [{
              "type": 0,
              "value": "Checklist Name"
            }]
          })
        }), /*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "filtersCount.appointmentType",
          sx: {
            minWidth: '140px',
            maxWidth: '140px'
          },
          tableCellProps: {
            sx: {
              minWidth: '140px',
              maxWidth: '140px'
            }
          },
          title: intl.formatMessage({
            id: "CfJP9r",
            defaultMessage: [{
              "type": 0,
              "value": "Appt Types"
            }]
          })
        }), /*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "filtersCount.facility",
          sx: {
            minWidth: '140px',
            maxWidth: '140px'
          },
          tableCellProps: {
            sx: {
              minWidth: '140px',
              maxWidth: '140px'
            }
          },
          title: intl.formatMessage({
            id: "Z/P45E",
            defaultMessage: [{
              "type": 0,
              "value": "Facilities"
            }]
          })
        }), /*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "filtersCount.provider",
          sx: {
            minWidth: '140px',
            maxWidth: '140px'
          },
          tableCellProps: {
            sx: {
              minWidth: '140px',
              maxWidth: '140px'
            }
          },
          title: intl.formatMessage({
            id: "IL1Uey",
            defaultMessage: [{
              "type": 0,
              "value": "Providers"
            }]
          })
        }), /*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "filtersCount.custom",
          sx: {
            minWidth: '140px',
            maxWidth: '140px'
          },
          tableCellProps: {
            sx: {
              minWidth: '140px',
              maxWidth: '140px'
            }
          },
          title: intl.formatMessage({
            id: "TVHxE/",
            defaultMessage: [{
              "type": 0,
              "value": "Custom Logic"
            }]
          })
        }), /*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "updatedAt",
          sx: {
            width: '258px'
          },
          tableCellProps: {
            sx: {
              width: '258px'
            }
          },
          title: intl.formatMessage({
            id: "xrk6zg",
            defaultMessage: [{
              "type": 0,
              "value": "Updated"
            }]
          })
        }), /*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "createdBy",
          sx: {
            width: '258px'
          },
          tableCellProps: {
            sx: {
              width: '258px'
            }
          },
          title: intl.formatMessage({
            id: "ORGv1Q",
            defaultMessage: [{
              "type": 0,
              "value": "Created"
            }]
          })
        }), /*#__PURE__*/_jsx(ContainerTableColumn, {
          dataIndex: "status",
          sx: {
            width: '140px'
          },
          tableCellProps: {
            sx: {
              width: '140px'
            }
          },
          title: intl.formatMessage({
            id: "tzMNF3",
            defaultMessage: [{
              "type": 0,
              "value": "Status"
            }]
          })
        }), _ContainerTableColumn || (_ContainerTableColumn = /*#__PURE__*/_jsx(ContainerTableColumn, {
          isMenu: true,
          title: "",
          dataIndex: "action"
        }))]
      }))
    })]
  });
}